<template>
  <div class="timeline">
    <span v-for="(dateEvents, date) in timeline" :key="date">
      <div class="timeline-block" v-for="(timeEntry, time) in dateEvents" :key="time">
        <div class="timeline-content" :class="{ even: timeEntry.counter%2 === 0}">
          <div class="event" v-for="(event, key) in timeEntry.events" :key="key" >
            <div class="timeline-time" :class="'code-' + event.code">
              <i class="fa fa-lg time-line-ico" :class="icons['code-' + event.code] || 'fa-circle'" />
            </div>
            <!-- <strong>{{ event.code_description }}</strong> -->
            <p><b>{{ date + ' · ' + time }}: </b>{{ event.details.message }}</p>
          </div>
        </div>
      </div>
    </span>
  </div>
</template>

<script>
import icon from './../svg/events'
import moment from 'moment'

export default {
  name: 'shipmentTimeLine',
  props: ['shipment'],
  components: {icon},
  computed: {
    timeline () {
      let timeline = {}
      if (this.shipment.events) {
        let counter = 0
        this.shipment.events.forEach(event => {
          if (!event.code_description) {
            return
          }
          let dateString = moment(event.walltime).format('YYYY-MM-DD')
          let timeString = moment(event.walltime).format('HH:mm')
          if (!timeline[dateString]) {
            timeline[dateString] = {}
          }
          if (!timeline[dateString][timeString]) {
            counter = counter + 1
            timeline[dateString][timeString] = { counter: counter, events: [] }
          }
          if (!this.isRepeated(timeline[dateString][timeString].events, event)) {
            timeline[dateString][timeString].events.push(event)
          }
        })
      }
      return timeline
    }
  },
  data () {
    return {
      icons: {
        'code-0': 'fa-exchange-alt',
        'code-5': 'fa-ship',
        'code-6': 'fa-anchor',
        'code-9': 'fa-bullhorn',
        'code-20': 'fa-map-marker-alt',
        'code-40': 'fa-history',
        'code-100': 'fa-arrow-right',
        'code-10002': 'fa-calendar-day'
      }
    }
  },
  methods: {
    isRepeated (array, event) {
      var finds = array.filter((ev) => {
        // eslint-disable-next-line
        return ev.details.message === event.details.message && JSON.stringify(ev.walltime) == JSON.stringify(event.walltime)
      })
      return finds.length > 0
    }
  }
}
</script>


<style lang="scss">
  .timeline {
    position: relative;
    padding: 0 0 em 0;
    margin-top: 3em;
    margin-bottom: 3em;
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 15px;
      margin-left: -2px;
      height: 100%;
      width: 4px;
      background: #88888d;
    }
  }

  .timeline-block {
    position: relative;
    /*
    margin: 4em 0 3em 0; */
  }
  .timeline-block:after {
    content: "";
    display: table;
    clear: both;
  }
  .timeline-block:first-child {
    margin-top: 0;
  }

  .timeline-date {
    position: relative;
    width: 120px;
    text-align: center;
    line-height: 2.5em;
    background-color: #B6C5DA;
    color: white;
    top: 0;
    left: 50%;
    margin-left: -60px;
  }
  .timeline-time {
    width: 33px;
    height: 33px;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 50%;
    background: white;
    color: #009D96;
    border: 3px solid #009D96;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    
    &.code-0 {
      color: #ffb346;
      border-color: #ffb346;
    }


    &.code-40,&.code-5 {
      color: #1ca7d1;
      border-color: #1ca7d1;
    }
    
    &.code-100, &.code-9 {
      color:#90be6f;
      border-color: #90be6f;
    }
    &.code-10002,&.code-6 {
      color: #e73857;
      border-color: #e73857;
    }
  }
  .timeline-content {
    /* padding: 1em;
    width: 45%; */
  }
  .timeline-content::before {
   /*  top: 24px;
    left: 100%; */
    /* border-color: transparent;
    border-left-color: white; */
  }
  .timeline-block .timeline-content.even {
    //float: right;
  }
  .timeline-block .timeline-content.even::before {
    /* top: 24px;
    left: auto;
    right: 100%; *//* 
    border-color: transparent;
    border-right-color: white; */
  }
  .event{
    position: relative;
    padding: 10px 0;
    p {
      margin-left: 50px;
    }
    &:first-child{
      //padding-top: 0;
    }
    &:last-child{
      //padding-bottom: 0;
      border-bottom: none;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/ShipmentTimeLine.vue